// extracted by mini-css-extract-plugin
module.exports = {"stars":"star_rating_question-module__stars___u9uB3","star":"star_rating_question-module__star___lk9ql","selectedLabel":"star_rating_question-module__selectedLabel___F5sR6"};